import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 環境設定api
 */
class configApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
     * 查詢環境設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getConfig(callback = {}, is_loading = true) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_CONFIG}`,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 更新環境設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} id
     * @param {Object.<string, string>} params 更新參數
     */
    updateConfig(callback = {}, id, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.put,
          url: `${apiUrl.API_PUT_CONFIG}/${id}`,
          data: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 更新多筆環境設定
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     */
    updateMultiConfig(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_POST_MULTI_UPDATE_CONFIG}`,
          data: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

}

export default configApi;



// WEBPACK FOOTER //
// ./src/models/API/configApi.js